import React,{useState,useEffect} from "react"
import {Modal,ModalFooter,ModalHeader,ModalBody} from "reactstrap" 
import _ from "lodash"
import { useGlobal } from "./Reducer";
import Api from "./Api";
import Toggle from 'react-toggle'
import "react-toggle/style.css" 
import PollEditor from "./PollEditor";

const ACTIVE="ACTIVE";
const RESULT="RESULT";
export {ACTIVE,RESULT}


export default (props)=>{

    const mode=props.mode;
    const [gs,ga]=useGlobal();
    const [polls,setPolls]=useState([]);
    const [showEditor,setShowEditor]=useState(false);
    const [poll,setPoll]=useState(null);
    const [selectedPoll,setSelectedPoll]=useState(mode==ACTIVE?gs.appData.active_poll_id:gs.appData.result_poll_id);

const getPolls=()=>{
    ga.loading(true);
    Api.getAllPolls().then(({polls})=>{
        setPolls(polls);
    }).catch(err=>{
      
    }).finally(()=>{
        ga.loading(false);
    });
}

    const deletePolls=(poll)=>{
        ga.showBooleanAlert("Sure ?","are you sure you want to delete poll with title \""+poll.title+"\"?",()=>{
            ga.loading(true)
            Api.deletePoll(poll.id).then(()=>{
                getPolls()
            }).catch(err=>{
          
            }).finally(()=>{
                ga.loading(true)
            })
        });
    }

    useEffect(()=>{
        getPolls()
    },[]);

 
    return (<Modal isOpen={true} size="xl">
       {showEditor && <PollEditor 
       onClose={()=>{
           setShowEditor(false);
           getPolls();
       }}
       poll={poll}/>}
        <ModalHeader>{mode==ACTIVE?"Set Acive Poll":"Set Result Poll"}</ModalHeader>
        <ModalBody>
                <div style={{maxHeight:500,overflow:"auto"}}>
                    <table className="table table-striped table-condensed">
                            <thead>
                                <tr>
                                    <th>Poll Title</th>
                                    <th>Select</th>
                                  {mode==ACTIVE &&  <React.Fragment>
                                    <th>Edit</th>
                                    <th>Delete</th>
                                    </React.Fragment>}
                                </tr>
                            </thead>
                            <tbody>
                                   {_.map(polls,(poll,index)=>{
                                       return (<tr key={index+poll.title}>
                                           <td style={{maxWidth:300}}>{poll.title}</td>
                                           <td><Toggle
                                           onChange={e=>{
                                               if(e.target.checked==true)
                                               {
                                                   if(mode==ACTIVE)
                                                   {
                                                   
                                                setSelectedPoll(poll.id);   
                                                gs.appData.active_poll_id=poll.id;
                                                Api.setActivePoll(poll.id,gs.appData.id).then(()=>{
                                                    ga.setState({});
                                                });
                                                   }
                                                   else
                                                   {
                                                    setSelectedPoll(poll.id);   
                                                    gs.appData.result_poll_id=poll.id;
                                                    Api.setResultPoll(poll.id,gs.appData.id).then(()=>{
                                                        ga.setState({});
                                                    });
                                                           
                                                   }
                                               }
                                           }}
                                           checked={selectedPoll==poll.id}/></td>
                                         {mode==ACTIVE && <React.Fragment>
                                          <td><button 
                                           onClick={()=>{
                                               setPoll(poll);
                                               setShowEditor(true);
                                           }}
                                           className="btn btn-info btn-sm">Edit</button></td>
                                           <td><button
                                           onClick={()=>{
                                               deletePolls(poll);
                                           }}
                                           className="btn btn-danger btn-sm">Delete</button></td>
                                          </React.Fragment>}
                                       </tr>);
                                   })}
                            </tbody>

                    </table>
                </div>

        </ModalBody>
        <ModalFooter>
        {mode==ACTIVE &&<button onClick={()=>{
            setPoll(null);
            setShowEditor(true);
        }} className="btn btn-success">Add New Poll</button>}
            <button onClick={props.onClose} className="btn btn-secondary">Close</button>
        </ModalFooter>
    </Modal>);

}